import {
  Button,
  Container,
  Divider,
  Grid,
  Group,
  Paper,
  SimpleGrid,
  Stack,
} from '@mantine/core'
import AppSection from '../../component/layout/AppSection'
import React from 'react'
import { themeCfg } from '../../theme/theme'
import EntityDropdown from '../../component/form/EntityDropdown'
import AppDateInput from '../../component/form/AppDateInput'
import AppIcon from '../../component/common/AppIcon'
import AppToolbar from '../../component/layout/AppToolbar'
import AppButton from '../../component/common/AppButton'

const CashRegisters = () => {
  return (
    <AppSection
      header={
        <Group w="100%" justify="space-between">
          <Group>
            <EntityDropdown entity="center" />
          </Group>
          <Group>
            <AppButton bg="red" label="Cierre de Caja en Bloque" />
            <AppButton bg="orange" label="Reporting Días Faltan" />
            <AppButton bg="primary" label="Descontabilizar Cajas" />
          </Group>
        </Group>
      }
      // subheader={
      //   <AppToolbar />
      // }
    >
      <SimpleGrid w="100%" h="100%" cols={{ base: 1, lg: 2 }}>
        <Paper>
          <Stack>
            <Group w="100%" justify="space-between" align="center">
              <Group>
                <EntityDropdown entity="month" w={150} />
                <EntityDropdown entity="year" w={100} />
              </Group>
              <Button leftSection={<AppIcon icon="search" />} bg="gray">
                Buscar
              </Button>
            </Group>
            <Divider />
            <Group justify="flex-end">
              <Button leftSection={<AppIcon icon="cashRegistersClose" />}>
                Cerrar Cajas del Centro
              </Button>
              <Button bg="green" leftSection={<AppIcon icon="excel" />}>
                Excel Mes
              </Button>
            </Group>
            <Group>WIP...</Group>
          </Stack>
        </Paper>
        <Paper>
          <Stack>
            <Group w="100%" justify="space-between" align="center">
              <Group>
                <AppDateInput />
                <AppDateInput />
              </Group>
              <Button leftSection={<AppIcon icon="search" />} bg="gray">
                Buscar
              </Button>
            </Group>
            <Divider />
            <Group justify="flex-end">
              <Button leftSection={<AppIcon icon="sum" />}>Totales</Button>
              <Button bg="green" leftSection={<AppIcon icon="excel" />}>
                Excel
              </Button>
            </Group>
          </Stack>
        </Paper>
      </SimpleGrid>
    </AppSection>
  )
}

export default CashRegisters
